const baseUrl = window.location.origin;

const getUrlWithParams = (url: string, queryParams: object) => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      const valueArray = Array.isArray(value) ? value : [value];
      valueArray.forEach((val) => {
        params.append(key, val);
      });
    }
  });

  const query = params.toString();

  if (query.length > 0) {
    return `${url}?${query}`;
  }

  return url;
};

export interface PurchasePremiumPlanUrlParams {
  siteGuid?: string;
  referralAdditionalInfo: string;
  domainName?: string;
  showDomain?: boolean;
  referrer?: string;
}

export interface GetDomainUrlParams {
  referralAdditionalInfo?: string;
  domainName: string;
  msid?: string;
  referrer?: string;
  noHeader?: boolean;
  skipIntroPage?: boolean;
  flowType: 'purchase' | 'extend' | 'transferIn';
  isMobileFlow?: boolean;
}

export interface SplitPageStorefrontSharedParams {
  domainName: string;
  referralAdditionalInfo: string;
  referrer: string;
}

export interface SplitPageStorefrontAfterSignUpParams
  extends SplitPageStorefrontSharedParams {}

export interface SplitPageStorefrontParams
  extends SplitPageStorefrontSharedParams {
  locale?: string;
  shownPrices?: boolean;
  isMobileFlow?: boolean;
}

export interface GetDomainFlowsRedirectUrlParams {
  redirectUrl: string;
  msidCustomParam?: string;
  prefix?: string;
}

const getDomainFlowsRedirectUrl = (params: GetDomainFlowsRedirectUrlParams) => {
  return getUrlWithParams(
    `${baseUrl}/_serverless/domains-storefront-serverless/domains-flow-redirect`,
    params,
  );
};

export const NavigationService = {
  buyDomainUrl: (params: Omit<GetDomainUrlParams, 'flowType'>) =>
    getUrlWithParams(`https://manage.wix.com/get-domain`, {
      ...params,
      flowType: 'purchase',
    }),
  splitPageStorefrontAfterSignUp: (params: SplitPageStorefrontParams) =>
    getUrlWithParams(
      `https://manage.wix.com/premium-domains/bundle-selection`,
      params,
    ),

  splitPageStorefront: (params: SplitPageStorefrontParams) =>
    getUrlWithParams(
      `https://manage.wix.com/_serverless/domains-storefront-serverless/login-metasite-creation`,
      params,
    ),
  packagePicker: (params: PurchasePremiumPlanUrlParams) =>
    getUrlWithParams(`https://manage.wix.com/store/plans`, params),
  getDomainFlowsRedirectUrl,
  domainSearchResultsUrl: (params: { query: string }) =>
    getUrlWithParams(`${baseUrl}/domain/result`, params),
};
